import { useRef, useEffect, useState } from 'react';

import { Box, Button } from '@mui/material';

const LS_NAME = 'audioMessageRate';

const AudioModal = ({ url }) => {
  const audioRef = useRef(null);
  const [audioRate, setAudioRate] = useState(
    parseFloat(localStorage.getItem(LS_NAME) || '1'),
  );
  const [showButtonRate, setShowButtonRate] = useState(false);
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  useEffect(() => {
    audioRef.current.playbackRate = audioRate;
    localStorage.setItem(LS_NAME, audioRate);
  }, [audioRate]);

  useEffect(() => {
    audioRef.current.onplaying = () => {
      setShowButtonRate(true);
    };
    audioRef.current.onpause = () => {
      setShowButtonRate(false);
    };
    audioRef.current.onended = () => {
      setShowButtonRate(false);
    };
  }, []);

  const toggleRate = () => {
    let newRate = null;

    switch (audioRate) {
      case 0.5:
        newRate = 1;
        break;
      case 1:
        newRate = 1.5;
        break;
      case 1.5:
        newRate = 2;
        break;
      case 2:
        newRate = 0.5;
        break;
      default:
        newRate = 1;
        break;
    }

    setAudioRate(newRate);
  };

  const getAudioSource = () => {
    let sourceUrl = url;

    if (isIOS) {
      sourceUrl = sourceUrl.replace('.ogg', '.mp3');
    }

    return <source src={sourceUrl} type={isIOS ? 'audio/mp3' : 'audio/ogg'} />;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginRight: showButtonRate ? '120px' : '-30px',
        borderRadius: 8,
        backgroundColor: '#3d3d3d',
        width: 'fit-content',
        boxShadow: 1,
      }}
    >
      <audio
        ref={audioRef}
        controls
        style={{
          width: 300,
          height: 45,
        }}
      >
        {getAudioSource()}
      </audio>

      {showButtonRate && (
        <Button
          size='small'
          onClick={toggleRate}
          sx={{
            backgroundColor: 'transparent',
            color: ' #FFF',
            padding: '5px 0',
            minWidth: '50px',
            borderRadius: 50,
            border: 'none',
            margin: '0 5px 0 -20px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {audioRate}x
        </Button>
      )}
    </Box>
  );
};

export default AudioModal;
